import React, { useState, useRef, useEffect } from 'react';

import { MioDropdownWrapper, MioDropdownMenu } from './MioDropdown.styles';

const MioDropdown = ({
  children,
  openOnHover,
  fullWidth,
  type,
  background,
  dropdownMenu: DropdownMenu,
  hoverBackground,
  customStyle,
  paddingStyle,
  left,
  width,
  id,
  testId,
  right,
  optionsWidth,
  optionsMarginRight
}) => {
  const menuWrapper = useRef(null);
  const menuListWrapper = useRef(null);
  const [menuOpenClass, setMenuOpenClass] = useState('');
  const [menuListStyle, setMenuListStyle] = useState({});
  const targetEventsProps = {};

  const handleClickOutside = (e) => {
    if (menuWrapper.current && !menuWrapper.current.contains(e.target)) {
      setMenuOpenClass('');
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!openOnHover) {
    targetEventsProps.onClick = () => {
      const menuClass = menuOpenClass === '' ? 'open' : '';
      setMenuOpenClass(menuClass);
    };
  }

  const onMenuMouseOver = () => {
    const menuParentWrapper = menuWrapper.current.clientWidth;
    const menuItemsWrapper = menuListWrapper.current.clientWidth;
    if (type !== 'date') {
      /*setMenuListStyle({
      left: `${(menuParentWrapper - menuItemsWrapper) / 2}px`,
    });*/
    }
  };

  return (
    <MioDropdownWrapper
      data-testid={testId}
      id={id}
      ref={menuWrapper}
      fullWidth={fullWidth}
      openOnHover={openOnHover}
      style={paddingStyle}
      onMouseOver={onMenuMouseOver}
      optionsWidth={optionsWidth}
      optionsMarginRight={optionsMarginRight}
      {...targetEventsProps}
    >
      {children}
      <MioDropdownMenu
        background={background}
        hoverBackground={hoverBackground}
        ref={menuListWrapper}
        className={`dropdown-menu ${menuOpenClass}`}
        style={customStyle}
        type={type}
        left={left}
        width={width}
        right={right}
      >
        {DropdownMenu}
      </MioDropdownMenu>
    </MioDropdownWrapper>
  );
};

export default MioDropdown;
